@if (label) {
    <div class="header">
        <fui-input-label [title]="label" [i18NParams]="i18nParams"
                         [valued]="true" [hovered]="hovered"></fui-input-label>
    </div>
}
<div class="main">
    <ng-content></ng-content>
</div>
